<template>
  <component :is="tag" :id="id" class="TypographyInputError">
    <slot></slot>
  </component>
</template>

<script>
export default {
  props: {
    id: {
      type: String
    },
    tag: {
      type: String,
      default: 'p'
    }
  }
}
</script>

<style lang="scss">
@import './src/assets/styles/colors.scss';

.TypographyInputError {
  font-size: 14.6px;
  font-weight: 400;
  line-height: 1.43;
  margin-top: 2px;
  color: $color-text-error;
}
</style>


// WEBPACK FOOTER //
// src/components/typography/TypographyInputError.vue